import { put, select } from 'redux-saga/effects'

import Lifecycle from 'common/modules/lifecycle'
import Zoid from 'common/modules/zoid'

import { creators } from '../actions'

import selectors from '../selectors'

export function* watchInitFrame() {
    const haveAllFrameInitialized = yield select(selectors.haveAllFrameInitialized)

    if (haveAllFrameInitialized) {
        yield put(Lifecycle.creators.picoReady())
        yield put(creators.picoReady())
    }
}

export function* watchCreateFrame({ frame, payload }) {
    const { sendHostMessage } = yield select(Zoid.selectors.getXprops)
    sendHostMessage(`FRAME/CREATE_CHILD/${frame}`, payload)
}
export function* watchHideFrame({ frame, payload }) {
    const { sendHostMessage } = yield select(Zoid.selectors.getXprops)
    sendHostMessage(`FRAME/HIDE_CHILD/${frame}`, payload)
}
export function* watchShowFrame({ frame, payload }) {
    const { sendHostMessage } = yield select(Zoid.selectors.getXprops)
    sendHostMessage(`FRAME/SHOW_CHILD/${frame}`, payload)
}
export function* watchToggleFrame({ frame, payload }) {
    const { sendHostMessage } = yield select(Zoid.selectors.getXprops)
    sendHostMessage(`FRAME/TOGGLE_CHILD/${frame}`, payload)
}
export function* watchDestroyFrame({ frame, payload }) {
    const { sendHostMessage } = yield select(Zoid.selectors.getXprops)
    sendHostMessage(`FRAME/DESTROY_CHILD/${frame}`, payload)
}
